export default (
    'ontouchstart' in window
    &&
    window.matchMedia('screen and (max-width: 600px)').matches
)